import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Invoices.types'

@Injectable({ providedIn: 'root' })
export class Invoices_deactivate_billing_contract_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { contractId: number }): Promise<{ success?: boolean, messages?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.contractId)) {
      missingRequiredInParams.push('\'contractId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/functions/deactivate_billing_contract_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

